define('../app/fukit/view/header.nav.view',['require','exports','module','lodash','../config','uikit/uikit','../blockit.shared','backbone.radio','marionette','../helpers/route.helper','../helpers/roles.helper','../behavior/resolve.options.behavior','../behavior/authorization.behavior','../resources/commonSvgs','handlebars','lodash'],function(require, exports, module) {
  //prettier-ignore
  var lodash                 = require('lodash'),
      config                 = require('../config'),
      UIKit                  = require('uikit/uikit'),
      BlocKit                = require('../blockit.shared'),
      Radio                  = require('backbone.radio'),
      Mn                     = require('marionette'),
      RouteHelper            = require('../helpers/route.helper'),
      RolesHelper            = require('../helpers/roles.helper'),
      ResolveOptionsBehavior = require('../behavior/resolve.options.behavior'),
      AuthorizationBehavior  = require('../behavior/authorization.behavior'),
      commonSvgs             = require('../resources/commonSvgs'),
      Handlebars             = require('handlebars'),
      _                      = require('lodash');

  var HeaderNavView = UIKit.Menu.extend({
    className: UIKit.Menu.prototype.className + ' shared-header-nav',
    options: lodash.extend({}, UIKit.Menu.prototype.options, {
      fixed: true,
      title: false,
    }),

    behaviors: {
      ResolveOptionsBehavior: {
        behaviorClass: ResolveOptionsBehavior,
      },
    },

    simple: function(item) {
      return {};
    },

    internalViewOptions: {},

    buildSimpleMenuItem: function(item) {
      return {
        type: UIKit.Menu.Item.extend({
          attributes: { style: 'font-weight: bold;' },
        }),
        text: item.text,
        subMenu: false,
        link: true,
        onPress: function() {
          if (item.route) {
            RouteHelper.navigate(item.route, {}, { trigger: true });
          } else if (item.link) {
            window.location = item.link;
          }
        },
        behaviors: {
          BindAndFormatOptionValuesFromRouteBehavior: {
            model: this.routeModel,
            activeRoutes: item.activeRoutes,
            optionValues: {
              active: {
                formatter: function(model) {
                  return this.getOption('activeRoutes').indexOf(model.get('route')) > -1;
                },
              },
            },
            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
          },
        },
      };
    },

    buildDropdownMenuItem: function(item) {
      return {
        type: UIKit.Dropdown,
        className: UIKit.Dropdown.prototype.className + ' header-dropdown',
        icon: false,
        behaviors: {
          SetActiveClassOnDropdownHeader: {
            model: this.routeModel,
            activeRoutes: item.activeRoutes,
            behaviorClass: Mn.Behavior.extend({
              initialize: function(context) {
                var activeRoutes = this.getOption('activeRoutes');
                var updateheaderClass = function(route) {
                  if (activeRoutes.indexOf(route) > -1) {
                    this.$el.addClass('active-header');
                  } else {
                    this.$el.removeClass('active-header');
                  }
                };
                this.listenTo(this.view, 'render', function() {
                  updateheaderClass.bind(this)(this.getOption('model').get('route'));
                });
                this.listenTo(context.model, 'change:route', function(mod, route) {
                  updateheaderClass.bind(this)(route);
                });
              },
            }),
          },
          BindAndFormatOptionValuesBehavior: {
            optionValues: {
              text: {
                formatter: function() {
                  //prettier-ignore
                  return new Handlebars.SafeString(
                      '<span class="dropdown-text">' + item.text + '</span>'
                      + '<i class="icon dropdown"></i>'
                  );
                },
              },
              collection: {
                formatter: function() {
                  var actions = [];
                  item.children.forEach(function(child) {
                    var newItem = child;
                    if (child.route) {
                      newItem.link = RouteHelper.resolve(child.route);
                    }
                    if (child.header) {
                      newItem = new UIKit.Dropdown.HeaderModel(child);
                      newItem.unset('link');
                    }
                    actions.push(newItem);
                  });
                  return new Backbone.Collection(actions);
                },
              },
            },
            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
          },
          ResolveOptionsBehavior: {
            behaviorClass: ResolveOptionsBehavior,
          },
        },
        resolveOptions: {
          model: '@resources.userPrincipalModel',
        },
        childViewOptions: {
          bindings: {
            target: 'target',
            text: 'text',
            icon: 'icon',
            imageUrl: 'thumbnail',
            imageAlt: 'imageAlt',
            imageWidth: 'imageWidth',
            imageHeight: 'imageHeight',
            link: 'link',
            hasAction: 'hasAction',
          },
        },
      };
    },

    filterOutInvisibleNavigationItems: function(item) {
     if (item.visible === false) {
       return false;
     }
     if(!item.visibleOnlyWhen) {
      return true;
     }
     if (!_.isArray(item.visibleOnlyWhen)) {
       item.visibleOnlyWhen = [item.visibleOnlyWhen];
     }

     return item.visibleOnlyWhen.every(
       function(option) {
         if (_.isUndefined(option.roles)) {
           return true;
         }

         if (!_.isFunction(option.filter)) {
           return RolesHelper.evaluateRolesOptions(option.roles);
         }

         return !option.filter.call(this) || RolesHelper.evaluateRolesOptions(option.roles);
       }.bind(this)
     );
   },

    buildAndAddComponents: function(self, items) {
      // It looks like the navigation configuration was doing this work in its
      // own special way. I'm doing my best here to replicate the existing logic.
      items = items.filter(this.filterOutInvisibleNavigationItems);

      // Filter out invisible drop-down children
      items.forEach(
        function(item) {
          if(item.children && item.children.length) {
            item.children = item.children.filter(this.filterOutInvisibleNavigationItems);
          }
        }.bind(this)
      );

      if (items.length === 0) {
        $('#app-header').addClass('no-nav');
        this.$el.hide();
        return;
      }
      items.forEach(function(item) {
        var component;

        item.activeRoutes = Array.isArray(item.activeRoutes)
          ? item.activeRoutes
          : Array.isArray(item.children)
          ? item.children
              .map(function(child) {
                return child.route;
              })
              .filter(function(route) {
                return !_.isUndefined(route);
              })
          : [];
        if (item.route) {
          item.activeRoutes.push(item.route);
        }

        if (!item.children || !item.children.length) {
          component = self.buildSimpleMenuItem(item);
        } else {
          component = self.buildDropdownMenuItem(item);
        }

        var componentName = component.text;
        self.internalViewOptions[componentName] = component;
        self.add(self.buildComponent({ name: componentName }));
      });
    },

    initialize: function() {
      this.routeModel = new Backbone.Model();
      this.listenTo(
        Backbone.history,
        'before:route',
        function(context, route) {
          this.routeModel.set('route', route);
        }.bind(this)
      );
      //prettier-ignore
      UIKit.Menu.prototype.initialize.apply(this, arguments);

      var items = Radio.channel('navigationConfiguration').request('items');
      if (items) {
        this.buildAndAddComponents(this, items);
      } else {
        this.listenToOnce(
          Radio.channel('app'),
          'ready',
          function() {
            items = Radio.channel('navigationConfiguration').request('items');
            this.buildAndAddComponents(this, items);
          }.bind(this)
        );
      }
    }, // end of initilize
  });

  module.exports = HeaderNavView;
});

